import React, { ForwardedRef, forwardRef } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { ReleaseType } from '@callmart/types';
import { useStrategicVolumeReportSummary } from '../../hooks/api/strategicVolumeReports';
import { StrategicVolumeReportsTabPropsInterface } from '../../types/BiddingOverviewTabProps.interface';
import TableGridItem from '../UI/TableGridItem';
import { ColorizedNameRenderer, StrategicVolumeStatusCellRenderer } from '../../utils/agGridUtils';
import { EMPTY_VALUE, ReleaseTypeText } from '../../types/StrategicVolumeSummary';

function StrategicVolumeReportsTab(
    { columnDefs, date, onSelectionChanged, isTEFUser }: StrategicVolumeReportsTabPropsInterface,
    ref: ForwardedRef<any>
) {
    const { data: strategicVolumeReports } = useStrategicVolumeReportSummary({ date });

    return (
        <TableGridItem
            ref={ref}
            defaultColDef={{
                editable: false,
                filter: true,
                sortable: true,
            }}
            columnDefs={columnDefs}
            rowData={strategicVolumeReports}
            groupDisplayType={'groupRows'}
            groupDefaultExpanded={-1}
            groupLockGroupColumns={-1}
            groupRowRendererParams={{
                innerRenderer: ({ value, node }: ICellRendererParams) => {
                    return node?.field === 'release'
                        ? StrategicVolumeStatusCellRenderer({
                              value: String(value || ReleaseTypeText.UNDEFINED),
                          })
                        : ColorizedNameRenderer({ value, emptyValue: EMPTY_VALUE });
                },
                suppressCount: true,
                checkbox: isTEFUser,
                emptyValue: EMPTY_VALUE,
            }}
            suppressMakeColumnVisibleAfterUnGroup={true}
            rowSelection={
                isTEFUser
                    ? {
                          mode: 'multiRow',
                          selectAll: 'filtered',
                          groupSelects: 'filteredDescendants',
                          hideDisabledCheckboxes: true,
                          enableClickSelection: true,
                          enableSelectionWithoutKeys: true, // if true it will imitate pressed CTRL
                          isRowSelectable: ({ data, group, allLeafChildren }) => {
                              if (!group) return data?.release === ReleaseType.NOT_RELEASED;
                              return (allLeafChildren ?? []).some(
                                  (leaf) => leaf.data?.release === ReleaseType.NOT_RELEASED
                              );
                          },
                      }
                    : undefined
            }
            onSelectionChanged={onSelectionChanged}
        ></TableGridItem>
    );
}

export default forwardRef(StrategicVolumeReportsTab);
